import { useState } from "react";
import { Trophy, Download } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";

function recapText(match) {
  const t = match.match_type;
  let score;
  if (t === "official") score = `Nous ${match.our_score ?? 0} - ${match.opponent_score ?? 0} ${match.opponent_name || "Adversaire"}`;
  else if (t === "gala") score = `${match.team_a_name || "Équipe A"} ${match.score_team_a ?? 0} - ${match.score_team_b ?? 0} ${match.team_b_name || "Équipe B"}`;
  else score = `Bleus ${match.score_bleus ?? 0} - ${match.score_rouges ?? 0} Rouges`;
  return `⚽ Récap du match — ASS les Régionnaires\n${match.title ? match.title + "\n" : ""}${score}\n${window.location.origin}/matches/${match.id}`;
}

export default function RecapCardButton({ match }) {
  const [busy, setBusy] = useState(false);

  const fetchCard = async () => {
    const res = await fetch(`${API}/matches/${match.id}/share-card.png`, { credentials: "include" });
    if (!res.ok) throw new Error("échec");
    return res.blob();
  };

  const download = async (blob) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `recap-${match.id}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
    toast.success("Carte récap téléchargée");
  };

  const run = async (mode) => {
    setBusy(true);
    try {
      const blob = await fetchCard();
      const file = new File([blob], "recap.png", { type: "image/png" });
      const data = { title: "ASS les Régionnaires", text: recapText(match), files: [file] };
      if (mode === "share" && navigator.canShare && navigator.canShare(data)) {
        await navigator.share(data);
      } else {
        await download(blob);
      }
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Erreur de génération");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="inline-flex gap-2" data-testid="recap-card-actions">
      <button
        data-testid="recap-card-share-button"
        type="button"
        onClick={() => run("share")}
        disabled={busy}
        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-[#E5B85C] hover:bg-[#D4A24E] text-[#0B0F17] font-bold uppercase tracking-wide text-sm transition-colors disabled:opacity-60"
      >
        <Trophy className="w-4 h-4" /> {busy ? "Génération…" : "Partager le récap"}
      </button>
      <button
        data-testid="recap-card-download-button"
        type="button"
        onClick={() => run("download")}
        disabled={busy}
        title="Télécharger la carte récap (PNG)"
        className="inline-flex items-center px-3 py-2.5 rounded-lg bg-slate-800 hover:bg-slate-700 text-white disabled:opacity-60"
      >
        <Download className="w-4 h-4" />
      </button>
    </div>
  );
}
